import { __decorate } from "tslib";
import _ from 'lodash';
import { LEGAL_STATUS_MAP } from '../constants';
import { injectable } from '@/inversify.config';
let LegalStatusApiDtoImpl = class LegalStatusApiDtoImpl {
    formateLegalConfig(data) {
        const result = [];
        _.mapValues(data, (value, key) => {
            _.mapValues(value, (codeValue, code) => {
                result.push({
                    codeType: LEGAL_STATUS_MAP[key],
                    label: _.get(codeValue, 'title', {}),
                    color: _.get(codeValue, 'color', ''),
                    desc: _.get(codeValue, 'desc', {}),
                    isEpStatus: _.get(codeValue, 'ep_code', false),
                    epLabel: _.get(codeValue, 'ep_legal_group_title', {}),
                    epDesc: _.get(codeValue, 'ep_legal_group_desc', {}),
                    relatedCode: _.get(codeValue, 'related_code', []),
                    code,
                });
            });
        });
        return result;
    }
};
LegalStatusApiDtoImpl = __decorate([
    injectable()
], LegalStatusApiDtoImpl);
export { LegalStatusApiDtoImpl };
